import type { NavigateFunction } from 'react-router-dom';
import { resolveErrorType } from '@/helpers/resolveErrorType';
import type {
  ErrorLocationState,
  ErrorType,
} from '@/Pages/Error/types/errorLocationState';

export type NavigateToErrorInput = Omit<ErrorLocationState, 'errorType'> & {
  error?: unknown;
  errorType?: ErrorType;
};

function resolveCanRetry(
  errorType: ErrorType,
  input: NavigateToErrorInput,
): boolean | undefined {
  if (input.canRetry !== undefined) {
    return input.canRetry;
  }
  // Repetir não muda nada: a sessão morreu ou o cadastro já existe.
  if (errorType === 'auth' || errorType === 'already_onboarded') {
    return false;
  }
  if (input.originPath) {
    return true;
  }
  return undefined;
}

export function navigateToError(
  navigate: NavigateFunction,
  input: NavigateToErrorInput,
): void {
  const { error, errorType: explicitType, ...rest } = input;
  const errorType = explicitType ?? resolveErrorType(error);
  const canRetry = resolveCanRetry(errorType, input);

  const state: ErrorLocationState = {
    errorType,
    ...rest,
    ...(canRetry !== undefined ? { canRetry } : {}),
  };

  navigate('/error', { replace: true, state });
}
